import React, { ReactNode } from 'react';
import AccountMenu from '@components/account/AccountMenu';
import { Breadcrumb } from 'geniebook-ui/dist';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { activeSubjectSlug } from '@atom/activeSubjectStore';
import { useSubjectMenuList } from '@hooks/student.hook';
import { convertToSlug } from '@utils/helpers/convertToSlug';
import { useIsJCUser } from '@hooks/user.hook';

interface AccountLayoutProps {
  children: ReactNode;
  setShowAccountDropdown?: React.Dispatch<React.SetStateAction<boolean>>;
  showAccountDropdown?: boolean;
  className?: string;
}

const AccountLayout = (props: AccountLayoutProps) => {
  const navigate = useNavigate();
  const [activeSubject] = useAtom(activeSubjectSlug);
  const [subjectName, setSubjectName] = React.useState<string>('mathematics');
  const querySubjectMenuList = useSubjectMenuList();
  const { isJC } = useIsJCUser({ subjectId: undefined, generalPage: true });

  React.useEffect(() => {
    const data = querySubjectMenuList?.data?.data?.data;
    if (data?.[0]) {
      setSubjectName(convertToSlug(data[0].display_name));
    }
  }, [querySubjectMenuList?.data?.data?.data]);

  React.useEffect(() => {
    if (activeSubject) setSubjectName(activeSubject);
  }, [activeSubject]);

  const breadcrumbItems = [
    {
      title: 'Home',
      onClick: () => {
        navigate(`/${subjectName}/worksheets`);
      },
    },
  ];

  return (
    <div
      className={
        'flex lg:justify-center items-start mt-7 max-lg:pb-5 lg:pb-0 ' +
        props.className
      }
    >
      <div className="lg:w-3/12 max-lg:hidden">
        <Breadcrumb items={breadcrumbItems} icon="house" className="mb-10" />
        <AccountMenu
          setShowAccountDropdown={props.setShowAccountDropdown}
          showAccountDropdown={props.showAccountDropdown}
          isJC={isJC}
        ></AccountMenu>
      </div>
      <main className="lg:w-9/12 max-lg:w-full">{props.children}</main>
    </div>
  );
};

export default AccountLayout;
